import { TextField } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { validateTime } from '../../../../utils/commonFunctions';
import theme from 'src/theme/theme';
import TextButton from '../../../atomsLegacy/buttons/TextButton';
import { PickerContainer } from '../DateQuestion/DateQuestion.styles';
import QuestionContainer from '../QuestionContainer';
import { TextQuestionContent } from '../TextQuestion/TextQuestion';
import {
  QuestionInputContainer,
  QuestionInputHalfHeight,
  QuestionSubHeading,
} from '../TextQuestion/TextQuestion.styles';

const standardTimeFieldSx = {
  '& .MuiInput-underline:before': {
    borderBottomColor: theme.newPalette.turquoise.T300,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.newPalette.turquoise.T300,
  },
  '&:hover .MuiInput-underline:before': {
    borderBottomColor: theme.newPalette.turquoise.T400,
  },
};

interface Props {
  organisation: string;
  setEventTime(time: string): void;
  time: string;
}

export const TimeQuestion: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const invalidTime = props.time !== '' && !validateTime(props.time);

  const [showApproximateQuestion, setShowApproximateQuestion] =
    React.useState(invalidTime);

  return (
    <QuestionContainer
      organisation={props.organisation}
      backLink={'date'}
      nextLink={'location'}
      requireAnswer={
        (props.time === '' || invalidTime) && !showApproximateQuestion
      }
      textFieldValue={showApproximateQuestion ? props.time : ''}
      i18nHeader={'public.Time.header'}
      percentage={40}
      submitAnswer={() => props.setEventTime(props.time)}
    >
      {showApproximateQuestion ? (
        <TextQuestionContent
          organisation={props.organisation}
          textFieldValue={props.time}
          i18nDescription={'public.Time.approximateDescription'}
          i18nPlaceholder={'public.Time.approximatePlaceholder'}
          setQuestionData={(text) => {
            props.setEventTime(text);
          }}
        />
      ) : (
        <QuestionInputContainer>
          <QuestionInputHalfHeight>
            <QuestionSubHeading>
              {t('public.Time.description')}
            </QuestionSubHeading>

            <PickerContainer>
              <TextField
                id="time"
                data-testid="time-picker"
                type="text"
                placeholder="00:00"
                value={props.time}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  props.setEventTime(event.currentTarget.value)
                }
                error={invalidTime}
                helperText={invalidTime && t('public.Time.invalidTime')}
                variant="standard"
                fullWidth
                sx={standardTimeFieldSx}
              />
              {props.time === '' || invalidTime ? (
                <TextButton
                  onClick={() => setShowApproximateQuestion(true)}
                  data-testid={'not-sure-button'}
                  label={t('Buttons.notSure')}
                  notSureButton
                />
              ) : null}
            </PickerContainer>
          </QuestionInputHalfHeight>
        </QuestionInputContainer>
      )}
    </QuestionContainer>
  );
};

export default TimeQuestion;
